import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { filter, contains } from 'lodash/fp'
import { useQuery } from '../utils/hooks.js'
import '../utils/query.js'

import Page from '../components/layout/index.jsx'
// import ImageGrid from '../components/item-grid'

{ /* <ImageGrid
items={favorites}
imgSize="?w=250&h=187&crop=focalpoint&fit=crop&fp-x=.5&fp-y=.5&fp-z=2"
/> */ }

function Favorites(props) {
  const { data, location } = props
  const { items } = data
  const { nodes } = items

  const [query] = useQuery(location, { arrayFormat: 'comma', parseNumbers: true })
  const [favorites, setFavorites] = useState([])

  useEffect(() => {
    if (query && query.fabrics) {
      const fabricList = filter(({ id }) => contains(id, query.fabrics), nodes)
      setFavorites(fabricList)
    }
  }, [nodes, query])

  return (
    <Page path="/favorites">
      <div className="topMatter">
        <h2 className="uppercase">Favorites</h2>
        <p className="blurb">
          Click the
          {' '}
          <span className="favIcon">[+]</span>
          {' '}
          to add items to your Favorites.
        </p>
        <p className="blurb">Collected favorites may then be shared as a link, or, downloaded as a PDF</p>
      </div>

    </Page>
  )
}

Favorites.propTypes = {
  data: PropTypes.shape({
    items: PropTypes.shape({
      nodes: PropTypes.arrayOf(PropTypes.object),
    }),
  }).isRequired,
}
export default Favorites

// This should probably be replaced with an API call for individual item data.
export const pageQuery = graphql`
  query FavoriteAllItems {
    items:allColorItem(
      sort: { fields: [id], order: ASC }
    ) {
      nodes {
        pattern {
          ...PatternFields
          category {
            code,
            columns(detailOnly: true) {
              field {
                id
              }
              hideIfAnon
              label
            }
            id
            slug
          }
        }
        ...ItemFields
      }
    }
  }
`
